import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { customerFocusProductOrderSelectProductLine } from '../../../actions';
import { translator } from '../../../utils/Translator';

const ProductLineFilter = () => {
    const dispatch = useDispatch()
    const { authUser } = useSelector(({auth}) => auth);
    const { productLineProductOrderSelected } = useSelector(({customerFocus}) => customerFocus)
    const { translate } = useSelector(({ i18n }) => i18n);
    const [productLineData, setProductLineData] = useState([]);
    const [selected, setSelected] = useState(productLineProductOrderSelected);
    
    const handleChange = (selected) => {
        setSelected(selected)
        dispatch(customerFocusProductOrderSelectProductLine(selected))
    }

    useEffect(() => {
        let params = {
          company: authUser.company !== "#" ? authUser.company : "",
          salesmanCode: authUser.salesman !== "#" ? authUser.salesman : "",
          username: authUser.username,
          language: 1
        }
    
        const url = `${process.env.REACT_APP_API_URL}customer/findProductGroup?company=${params.company}&language=${params.language}`;
        axios.get(url).then(res => {
            setProductLineData(res.data)
        })
      },[authUser, productLineProductOrderSelected])

    // const customStyles = {
    //     control: (base, state) => ({
    //       ...base,
    //       width: '150px',
    //       'min-width': '150px'
    //     }),
    // };

    return(
        <Select
            // styles={customStyles}
            value={selected}
            onChange={handleChange}
            options={productLineData}
            placeholder={translator(translate.ISA_ProductType, "ประเภทสินค้า")}
            isClearable={true}
            />
    );
}

export default ProductLineFilter;